export const useDandyBillingAddress = () => ({
    name: 'ZIMA INTERNATIONAL, INC.',
    street_one: 'P.O. Box 738550',
    city: 'Dallas',
    state: 'TX',
    postal_code: '75373-8550',
    country: 'US',
});
